import React, { useEffect } from 'react'
import banner from '../Images/abouttwo.jpg'
import one from '../Images/Attraction/Master.webp'
import two from '../Images/Attraction/download.jpeg'
import three from '../Images/Attraction/images.jpeg'
import four from '../Images/Attraction/download (1).jpeg'


import Footer from '../Component/Footer/Footer'
import { MetaTags } from 'react-meta-tags'

const Attractions = () => {
     useEffect(()=>{
            window.scrollTo(0, 0);
        },[])
  return (
    <>
    <MetaTags>
                                <title>Best Resort In Neral | Seema Resort</title>
                                <meta title="Best Resort In Neral | Seema Resort" />
                                <meta name="description" content="Seema Resort is the best resort in Neral, offering luxurious stays, stunning views, and unforgettable experiences for all guests." />
                                <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                                <link rel="canonical" href="https://seemasresort.com/best-resort-neral" />
                                <meta http-equiv="cache-control" content="no-cache" />
                                <meta http-equiv="expires" content="0" />
                                <meta http-equiv="pragma" content="no-cache" />
                                <meta property="og:title" content=" Best Resort In Neral | Seema Resort" />
                                <meta property="og:locale" content="en_US" />
                                <meta property="og:type" content="website" />
                                <meta property="og:url" content="https://seemasresort.com/" />
                                <meta property="og:description" content="Seema Resort is the best resort in Neral, offering luxurious stays, stunning views, and unforgettable experiences for all guests." />
                                <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
                              </MetaTags>
     <section className=' About-Page-Section-Banner-Images'  style={{
    backgroundImage:`linear-gradient(90deg, rgba(0, 0, 0, .3), rgba(0, 0, 0, .4)), url(${banner})`
    ,backgroundSize:'cover',
    // height:'350px',objectFit:'cover'
    }}>
        <div className='About-Page-Section-Banner-Images-con'>
          <h2 className='mt-5 ms-5' style={{color:'white'}}> Attractions</h2>
        </div>
      </section>
      <div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>Best Resort In Neral</h1>
</div>
      <div className='container mt-5'>
        <div>
            <h4 className='text-center'>
            Explore Seema Resort's Nearby Attractions

            </h4>
            <p className='lead' style={{textAlign:'justify'}}>
            Greetings from Seema Resort, your starting point for adventure and leisure! Our resort, which is tucked away in the centre of Neral, provides quick access to some of the most breathtaking sights in the area. Everyone can find something to enjoy, regardless of whether they are leisure seekers or nature lovers. Discover why many people refer to us as Best Resort in Nerul.

            </p>
        </div>
        <div className='row justify-content-evenly p-2 '>
            <div className='col-12 col-lg-5 my-5 p-lg-2' style={{boxShadow:'0px 3px 5px gray' ,borderRadius:'25px',color:"#254222"}}>
                <div className='h-100 px-2' >
                <img src={one} className='mt-5' alt='img' style={{
                     height:'250px',
  width:'100%',
objectFit:'cover',
                    display:'flex',
                    margin:'auto'
                }}/>
                <div>
                    <h3 className='text-center mt-3'>The Hill Station in Matheran                    </h3>
                    <p className=' px-2' style={{textAlign:'justify',color:"#254222",fontFamily:"var(---Montserrat)"}}>
                    Matheran, a quaint hill station near Seema Resort, is well-known for its tranquil surroundings, picturesque vistas, and toy train rides. You may fully immerse yourself in nature at this environmentally conscious location since there are no cars there. Matheran's verdant surroundings and stunning sunsets make it an ideal destination for a revitalizing day trip while staying at the Best Resort.

                    </p>
                </div>
                </div>
            </div>
            
            
            <div className='col-12 col-lg-5 my-5 p-lg-2' style={{boxShadow:'0px 3px 5px gray' ,borderRadius:'25px',color:"#254222"}}>
                <div className='h-100 px-2' >
                <img src={two} className='mt-5' alt='img' style={{
                     height:'250px',
  width:'100%',
objectFit:'cover',
                    display:'flex',
                    margin:'auto'
                }}/>
                <div>
                    <h3 className='text-center mt-3'>The Jummapatti
                    </h3>
                    <p className=' px-2' style={{textAlign:'justify',color:"#254222",fontFamily:"var(---Montserrat)"}}>
                    The Neral-Matheran toy train track passes through the charming town of Jummapatti. It is well-known for its serene atmosphere and lush surroundings, making it a great place for leisurely strolls and photography. The impression is enhanced by the train's steady chug and the soft mountain breeze. You will have easy access to this stunning site while staying at Seema Resort, which further demonstrates why we are recognized as the Best Resort in Neral.

                    </p>
                </div>
                </div>
            </div>

<h3> When the rainy season is in effect, rainfall
</h3>

            <div className='col-12 col-lg-5 my-5 p-lg-2' style={{boxShadow:'0px 3px 5px gray' ,borderRadius:'25px',color:"#254222"}}>
                <div className='h-100 px-2' >
                <img src={three} className='mt-5' alt='img' style={{
                     height:'250px',
  width:'100%',
objectFit:'cover',
                    display:'flex',
                    margin:'auto'
                }}/>
                <div>
                    <h3 className='text-center mt-3'>Tapalwadi Waterfall</h3>
                    <p className=' px-2' style={{textAlign:'justify',color:"#254222",fontFamily:"var(---Montserrat)"}}>
                    The rainy season turns the Neral region into a waterfall wonderland.  Popular waterfall near Seema Resort is Tapalwadi Waterfall . A thrilling climb and a refreshing break are perfect for these magnificent natural treasures. The rushing sound of the water and the lush surroundings create a beautiful impression.
                    </p>
                </div>
                </div>
            </div>




            <div className='col-12 col-lg-5 my-5 p-lg-2' style={{boxShadow:'0px 3px 5px gray' ,borderRadius:'25px',color:"#254222"}}>
                <div className='h-100 px-2' >
                <img src={four} className='mt-5' alt='img' style={{
                     height:'250px',
  width:'100%',
objectFit:'cover',
                    display:'flex',
                    margin:'auto'
                }}/>
                <div>
                    <h3 className='text-center mt-3'>Ashane-Koshane Waterfall</h3>
                    <p className=' px-2' style={{textAlign:'justify',color:"#254222",fontFamily:"var(---Montserrat)"}}>
                    The rainy season turns the Neral region into a waterfall wonderland. Popular waterfalls near Seema Resort is Ashane-Koshane Waterfall. A thrilling climb and a refreshing break are perfect for these magnificent natural treasures. The rushing sound of the water and the lush surroundings create a beautiful impression.
                    </p>
                </div>
                </div>
            </div>


          


          



        </div>
        <div>
            <h4>Set Up Your Visit
            </h4>
            <p className='lead' style={{textAlign:'justify'}}>
            Seema Resort guarantees a restful and wonderful vacation. After touring these locations, return to our friendly environment and excellent service. Due to our near proximity to these natural wonders, your journey will be filled with cherished experiences. 
            </p>
            <p className='lead' style={{textAlign:'justify'}}>
            To join us in exploring the splendor of Neral, make your reservation right now!
            </p>
        </div>
    </div>
    <Footer/>
    </>
  )
}

export default Attractions
